// 调账

import { HttpBillNewsList } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import compUpdate from './update'
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpBillNewsList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add':
                    this.$router.push({
                        name: 'costbillingBillNewsUpdate',
                        params: { type: "add" },
                    });
                    break;
                case 'query':
                    this.operate = {
                        title: '查看',
                        show: true,
                        width:700,
                        component: "compUpdate",
                        showFooter: false,
                        querytype:'query',
                        activeid:params,
                    }
                    break;
                
                case 'edit':
                    var url=this.$router.resolve({
                        name: "costbillingBillNewsUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, status } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            }, 

            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCarrierAllList','getCarrierServiceList','getAlllogProCodeList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "账户",
                    key: 'EQ_account',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "状态",
                    key: 'EQ_active',
                    tag: 'vSelect',
                    options: [
                        {value:0,label:'启用'},
                        {value:1,label:'停用'},
                    ],
                    show:true,
                },
                {
                    label: "是否自动获取账单",
                    key: 'EQ_autoBill',
                    tag: 'vSelect',
                    options: [
                        {value:1,label:'是'},
                        {value:0,label:'否'}
                    ],
                },
                
                {
                    label: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流产品服务'}),
                    tag: 'vSelect',
                    key: 'EQ_carrierGroupId',
                    show:true,
                    options: this.getAlllogProCodeList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    show:true,
                }
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    maxWidth: 80,
                    render: this.getOperateNodes
                }, 
                {
                    title: '物流产品',
                    key: 'carrierGroupId',
                    render: (h, { row }) => this.findRenderLabel(this.getAlllogProCodeList, row.carrierGroupId)
                },
                {
                    title: '账户',
                    key: 'account',
                },
                {
                    title: '状态',
                    key: 'active',
                    render:(h,{row})=>{
                        return <div>{row.active == 0 ? '启用' : '停用'}</div>
                    }
                },
                {
                    title: '是否自动获取账单',
                    key: 'autoBill',
                    render:(h,{row})=>{
                        return <div>{row.autoBill == 0 ? '否' : '是'}</div>
                    }
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                }];
        },
    },
};




